export enum LS {
    /** Default language */
    defaultLang = 'def_lang',
    /** Current User */
    currentUser = 'currentUser',
    /** API url. Used for development */
    host = '_host'
}